import { Text, Flex } from '@pairy/pds-react';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import usePayPlan from '@/hooks/queries/pay/usePayPlan';
import { userInfoAtom } from '@/state/user/atom';

import PricePlanList from '../PricePlanList';
import {
  CouponAppliedAtom,
  PricePlanInfoAtom,
  SelectedPlanAtom,
} from '../index.atom';
import CouponInput from '../CouponInput';
import UpgradeButton from '../UpgradeButton';

import * as Styled from './index.styles';

interface Props {
  onOpenChange: (isOpen: boolean) => void;
}

const Content = ({ onOpenChange }: Props) => {
  const [isCouponApplied, setCouponApplied] = useAtom(CouponAppliedAtom);
  const setSelectedPlan = useSetAtom(SelectedPlanAtom);
  const setPricePlanInfo = useSetAtom(PricePlanInfoAtom);
  const userInfo = useAtomValue(userInfoAtom);

  const { refetch, data } = usePayPlan({
    select: (data) => data.data.data.plan.sort((a, b) => a.price - b.price),
    onSuccess: (data) => {
      if (!isCouponApplied) {
        setPricePlanInfo(data);
        setSelectedPlan(null);
      }
    },
    enabled: !isCouponApplied,
    suspense: true,
  });

  const handleCancelCoupon = () => {
    setCouponApplied(false);
    setSelectedPlan(null);
    refetch();
  };

  useEffect(() => {
    setSelectedPlan(null);
    setCouponApplied(false);

    return () => {
      setCouponApplied(false);
    };
  }, []);

  useEffect(() => {
    if (!isCouponApplied) {
      refetch();
    }
  }, [isCouponApplied]);

  return (
    <Styled.ContentContainer direction="column">
      {data && <PricePlanList />}

      <ErrorBoundary
        fallback={<div>에러 발생</div>}
        onError={() => {
          alert('결제창을 불러오는데 실패하였습니다 잠시 후 다시 시도해주세요');
        }}
      >
        <UpgradeButton onOpenChange={onOpenChange} />
      </ErrorBoundary>

      {userInfo?.subscriptionPlan.name === 'Free' ? (
        isCouponApplied ? (
          <Flex justifyContent="center">
            <Styled.CouponCancelWrapper
              width="fit-content"
              padding={{ x: 12, y: 8 }}
              onClick={handleCancelCoupon}
            >
              <Text variant="md-medium" color="cerise_500">
                적용된 쿠폰 취소하기
              </Text>
            </Styled.CouponCancelWrapper>
          </Flex>
        ) : (
          <CouponInput />
        )
      ) : null}
    </Styled.ContentContainer>
  );
};

export default Content;
